import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "mt-6"
};
const _hoisted_2 = {
    key: 1,
    class: "mt-6"
};
const _hoisted_3 = {
    key: 2,
    class: "centered"
};
import { ref, onMounted } from 'vue';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { useVouchers } from '@/composables/useVouchers';
import HeaderBlock from './elements/HeaderBlock.vue';
import VoucherList from './elements/VoucherList.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'FavoriteVouchersPage',
    setup(__props) {
        const state = useAppState();
        useAuth();
        const { getCustomer } = useCustomer();
        const { getAvailableVouchers, removeCustomerFavouriteDiscount, addCustomerFavouriteDiscount } = useVouchers();
        const favouriteVouchers = ref(null);
        const loading = ref(true);
        function onLoad() {
            getCustomer();
            loadAvailable();
        }
        function loadAvailable() {
            getAvailableVouchers(() => {
                favouriteVouchers.value = state.availableVouchers.filter((v) => v.favourite);
                loading.value = false;
            });
        }
        function favouriteToggled(voucher) {
            if (voucher.favourite) {
                removeCustomerFavouriteDiscount(voucher, () => {
                    voucher.favourite = !voucher.favourite;
                });
            }
            else {
                addCustomerFavouriteDiscount(voucher, () => {
                    voucher.favourite = !voucher.favourite;
                });
            }
        }
        onMounted(() => {
            onLoad();
        });
        return (_ctx, _cache) => {
            const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, { title: "Favourites" }),
                (favouriteVouchers.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createVNode(VoucherList, {
                            showAll: true,
                            vouchers: favouriteVouchers.value,
                            search: false,
                            showSaving: false,
                            showFavourites: true,
                            onFavouriteToggled: _cache[0] || (_cache[0] = (v) => { favouriteToggled(v); }),
                            formatter: _unref(state).formatter
                        }, null, 8, ["vouchers", "formatter"])
                    ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(8, (i) => {
                            return _createElementVNode("div", {
                                key: i,
                                class: "mb-2"
                            }, [
                                _createVNode(_component_v_skeleton_loader, { type: "list-item-avatar-two-line" })
                            ]);
                        }), 64))
                    ])),
                (!loading.value && favouriteVouchers.value && favouriteVouchers.value.length == 0)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_3, " You have not yet added any favourite vouchers. "))
                    : _createCommentVNode("", true),
                _cache[1] || (_cache[1] = _createElementVNode("div", { style: { "clear": "both" } }, null, -1))
            ], 64));
        };
    }
});
